import { useSelector, useDispatch } from "react-redux";
import { Text, Grid, Row, Col, } from "rsuite";
import React, { useEffect, useMemo } from "react";
import { getPropertyContactsByApplicationNumberAsync } from "../../../store/slices/licenseView/licenseViewThunks";
import { selectPropertyContacts, selectPropertyContactsInProgress, selectPropertyContactsSuccess, selectPropertyContactsErrorMsg } from "../../../store/slices/licenseView/licenseViewSelectors";
import IconIndicator from "../../user-feedback/IconIndicator";
import Notice from "../../user-feedback/Notice";
import { listOfUniquePeopleWithAllRoles } from "./helper";
import PropertyContact from "./PropertyContact";
import { selectGlobalsTranslations} from "../../../store/slices/globals/globalsSelectors";
import { C_DEFAULT_TRANSLATIONS } from "../../../common/consts";

const PropertyContacts = ({ applicationNumber }) => {
  const dispatch = useDispatch();

  const propertyContacts = useSelector(selectPropertyContacts);
  const propertyContactsLoading = useSelector(selectPropertyContactsInProgress);
  const propertyContactsSuccess = useSelector(selectPropertyContactsSuccess);
  const propertyContactsErrorMesage = useSelector(selectPropertyContactsErrorMsg);
  const translations = useSelector(selectGlobalsTranslations);

  useEffect(() => {
    dispatch(getPropertyContactsByApplicationNumberAsync(applicationNumber));
  }, [dispatch]);

  const organizedContacts = useMemo(() => {
    if (propertyContactsLoading) {
      return [];
    }
    else {
      return listOfUniquePeopleWithAllRoles(propertyContacts, translations, C_DEFAULT_TRANSLATIONS);
    }
  }, [propertyContacts, propertyContactsLoading])

  return (
    <Grid fluid>
      <Row className="mb-24">
        <Col xs={24}>
          <Text className="text-bold header-text-h4">Property Contacts</Text>
        </Col>
      </Row>

      {
        propertyContactsLoading && (
          <Row>
            <Col xs={24}>
              <IconIndicator />
            </Col>
          </Row>
        )
      }

      {
        !propertyContactsLoading && propertyContactsSuccess && organizedContacts.map(([data, roles], i) => (
          <Row key={`organized_contacts_${i}`}>
            <div role="cell">
              <PropertyContact key={i} data={data} roles={roles} />
            </div>
          </Row>
          
        ))
      }

      {
        !propertyContactsSuccess && !propertyContactsLoading && propertyContactsErrorMesage  && (
          <Row>
            <div role="cell">
              <Notice message={propertyContactsErrorMesage} />
            </div>
          </Row>
        )
      }
    </Grid>
  );
};

export default PropertyContacts; 
